export const featureFirestoreCache = (): boolean => {
  // フィーチャートグル: Firestore Cache 有効/無効判定
  return useRuntimeConfig().public.ENABLE_FIRESTORE_CACHE === "true";
};

export const featureConversion = (): boolean => {
  // フィーチャートグル: サンクスページ
  return useRuntimeConfig().public.ENABLE_CONVERSION === "true";
};

export const featurePlanMemberCountSetting = (): boolean => {
  // フィーチャートグル: 講座設定画面で会員数設定を表示するかどうか
  return useRuntimeConfig().public.ENABLE_PLAN_MEMBER_COUNT_SETTING === "true";
};

export const featureBulkDelivery = (): boolean => {
  // フィーチャートグル: 一斉配信
  return useRuntimeConfig().public.ENABLE_BULK_DELIVERY === "true";
};

export const featureBulkDeliveryDm = (): boolean => {
  // フィーチャートグル: 一斉配信DM
  return useRuntimeConfig().public.ENABLE_BULK_DELIVERY_DM === "true";
};

export const featureStepDelivery = (): boolean => {
  // フィーチャートグル: ステップ配信
  return useRuntimeConfig().public.ENABLE_STEP_DELIVERY === "true";
};

export const featureStepDeliveryDm = (): boolean => {
  // フィーチャートグル: ステップ配信DM
  return useRuntimeConfig().public.ENABLE_STEP_DELIVERY_DM === "true";
};

// ENABLE_NOTIF_PUSH_QUAY
export const featureNotifPushQuay = (): boolean => {
  // フィーチャートグル: 通知アプリ
  return useRuntimeConfig().public.ENABLE_NOTIF_PUSH_QUAY === "true";
};

// ENABLE_MULTI_PLAN_DISTRIBUTION
export const featureMultiPlanDistribution = (): boolean => {
  // フィーチャートグル: 複数講座同時投稿
  return useRuntimeConfig().public.ENABLE_MULTI_PLAN_DISTRIBUTION === "true";
};

// ENABLE_TALK_THREAD
export const featureTalkThread = (): boolean => {
  // フィーチャートグル: トークスレッド
  return useRuntimeConfig().public.ENABLE_TALK_THREAD === "true";
};

// ENABLE_TALK_MOVIE
export const featureTalkMovie = (): boolean => {
  // フィーチャートグル: トーク動画
  return useRuntimeConfig().public.ENABLE_TALK_MOVIE === "true";
};

// ENABLE_VIDEO_RESOLUTION_CHECK
export const featureVideoResolutionCheck = (): boolean => {
  // フィーチャートグル: 動画解像度チェック
  return useRuntimeConfig().public.ENABLE_VIDEO_RESOLUTION_CHECK === "true";
};

// ENABLE_MULTI_PART_UPLOAD
export const featureMultiPartUpload = (): boolean => {
  // フィーチャートグル: マルチパートアップロード
  return useRuntimeConfig().public.ENABLE_MULTI_PART_UPLOAD === "true";
};

// ENABLE_MOVIE_CHAPTERS
export const featureMovieChapters = (): boolean => {
  // フィーチャートグル: 動画チャプター機能
  return useRuntimeConfig().public.ENABLE_MOVIE_CHAPTERS === "true";
};

// ENABLE_EDUCATION_PLAN_TYPE
export const featureEducationPlanType = (): boolean => {
  // フィーチャートグル: 教育講座タイプ
  return useRuntimeConfig().public.ENABLE_EDUCATION_PLAN_TYPE === "true";
};

// ENABLE_PLAN_PRICE_LIMITED_PUBLISH
export const featurePlanPriceLimitedPublish = (): boolean => {
  // フィーチャートグル: 料金プラン限定公開
  return useRuntimeConfig().public.ENABLE_PLAN_PRICE_LIMITED_PUBLISH === "true";
};

// ENABLE_PLAN_PRICE_LIMITED_PUBLISH_TALKROOM
export const featurePlanPriceLimitedPublishTalkroom = (): boolean => {
  // フィーチャートグル: トークルーム料金プラン限定公開
  return useRuntimeConfig().public.ENABLE_PLAN_PRICE_LIMITED_PUBLISH_TALKROOM === "true";
};

// ENABLE_BADGE_SYSTEM
export const featureBadgeSystem = (): boolean => {
  // フィーチャートグル: バッジシステム
  return useRuntimeConfig().public.ENABLE_BADGE_SYSTEM === "true";
};

// ENABLE_VIEWING_RESTRICTION_DAYS
export const featureViewingRestrictionDays = (): boolean => {
  // フィーチャートグル: 入会後の経過日数による閲覧制限
  return useRuntimeConfig().public.ENABLE_VIEWING_RESTRICTION_DAYS === "true";
};

// ENABLE_CHASING_PLAYBACK
export const featureChasingPlayback = (): boolean => {
  // フィーチャートグル: 追っかけ再生機能
  return useRuntimeConfig().public.ENABLE_CHASING_PLAYBACK === "true";
};

// ENABLE_CLOUD_FUNCTIONS_UNREAD_CHECK
export const featureCloudFunctionsUnreadCheck = (): boolean => {
  // フィーチャートグル: Cloud Functionsを使った未読チェック
  return useRuntimeConfig().public.ENABLE_CLOUD_FUNCTIONS_UNREAD_CHECK === "true";
};

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    featureFirestoreCache: () => boolean;
    featureConversion: () => boolean;
    featurePlanMemberCountSetting: () => boolean;
    featureBulkDelivery: () => boolean;
    featureStepDelivery: () => boolean;
    featureBulkDeliveryDm: () => boolean;
    featureNotifLine: () => boolean;
    featureNotifPushQuay: () => boolean;
    featureMultiPlanDistribution: () => boolean;
    featureTalkThread: () => boolean;
    featureMultiPartUpload: () => boolean;
    featureMovieChapters: () => boolean;
    featureEducationPlanType: () => boolean;
    featurePlanPriceLimitedPublish: () => boolean;
    featurePlanPriceLimitedPublishTalkroom: () => boolean;
    featureBadgeSystem: () => boolean;
    featureViewingRestrictionDays: () => boolean;
    featureChasingPlayback: () => boolean;
    featureCloudFunctionsUnreadCheck: () => boolean;
  }
}
